import { Link } from 'react-router-dom'
import styled from 'styled-components'

import theme from 'theme_'

export const StyledHeaderLogo = styled(Link)`
  color: ${theme.colors.pelicanGrey};
  display: flex;
  flex-flow: column;
  gap: 6px;
  text-decoration: none;
`

export const StyledHeaderLogoWrapper = styled.div`
  max-width: 138px;
`

export const StyledHeaderLogoSubTitle = styled.div`
  font-size: 8px;
  letter-spacing: 2px;
  text-transform: uppercase;
`
